import React, { useState } from "react";
import { helpers } from "../../../services";
import config from "../../../config";
import { Tag } from "../../../components";
import useTranslation from "../../../hooks/useTranslation";

const Item = ({ list, ind, defaultCurrency, toggleClosedKeys, openedRows }) => {
	const { tr } = useTranslation();
	const [openedCompleted, setOpenedCompleted] = useState(false);
	const [opened, setOpened] = useState(false);
	const completedItems = list.filter(l => Number(l.status) === 20);
	const activeItems = list.filter(l => Number(l.status) !== 20);
	const parent = activeItems[0] || completedItems[0];
	const quantity = list.reduce((prev, curr) => prev + Number(curr.quantity), 0);
	const comingPrice = list.reduce(
		(prev, curr) => prev + Number(curr.coming_price),
		0
	);

	const sum = list.reduce((prev, curr) => prev + Number(curr.sum), 0);

	const isOpened = openedRows.includes(parent && parent.product_id);
	const toggleCompleted = () => setOpenedCompleted(prev => !prev);

	return (
		<>
			<tr>
				<td>
					<div className="d-flex align-items-center">
						<button
							className="table-toggle-button"
							onClick={() => {
								setOpened(prev => !prev);
								// toggleClosedKeys(parent.product_id);
							}}
						>
							{opened ? "-" : "+"}
						</button>
						<span className="text-link-style ws-no-wrap">
							{ind + 1}. {parent.name}
						</span>
					</div>
				</td>
				<td>{parent.unit}</td>
				<td className="text-cen">{helpers.convertToReadable(helpers.checkNumber(quantity))}</td>
				<td className="ws-no-wrap text-right">
					{helpers.convertToReadable(sum / quantity)}{" "}
					{defaultCurrency && defaultCurrency.toUpperCase()}
				</td>
				<td className="ws-no-wrap text-right">
					{helpers.convertToReadable(sum)}{" "}
					{defaultCurrency && defaultCurrency.toUpperCase()}
				</td>
				<td className="ws-no-wrap text-right">
					{helpers.convertToReadable(comingPrice)}{" "}
					{defaultCurrency && defaultCurrency.toUpperCase()}
				</td>
				<td className="ws-no-wrap text-right">
					{helpers.convertToReadable(sum - comingPrice)}{" "}
					{defaultCurrency && defaultCurrency.toUpperCase()}
				</td>
				<td>
					{" "}
					{list.length <= 1 &&
						(parent.status === 1 ? (
							<Tag color={"green"}>{tr("Завершено")}</Tag>
						) : (
							<Tag color={"blue"}>{tr("В процессе")}</Tag>
						))}
				</td>
			</tr>

			{opened && (
				<>
					{(completedItems.length > 0 && activeItems.length
						? activeItems
						: list
					).map(item => {
						const price = Number(item.price);
						const coming = Number(item.coming_price);
						const profit = Number(item.sum) - coming;
						return (
							<>
								<tr key={`active-${item.id}`}>
									<td>
										<span className="ws-no-wrap pl-30">{item.name}</span>
									</td>
									<td>{item.unit}</td>
									<td className="text-cen">{helpers.convertToReadable(helpers.checkNumber(item.quantity))}</td>
									<td className="text-right ws-no-wrap">
										{helpers.convertToReadable(price)}{" "}
										{defaultCurrency.toUpperCase()}
									</td>
									<td className="text-right ws-no-wrap">
										{helpers.convertToReadable(item.sum)}{" "}
										{defaultCurrency.toUpperCase()}
									</td>
									<td className="text-right ws-no-wrap">
										{helpers.convertToReadable(coming)}{" "}
										{defaultCurrency.toUpperCase()}
									</td>
									<td className="text-right ws-no-wrap">
										{helpers.convertToReadable(profit)}{" "}
										{defaultCurrency.toUpperCase()}
									</td>
									<td>
										{item.status === 1 ? (
											<Tag color={"green"}>{tr("Завершено")}</Tag>
										) : (
											<Tag color={"blue"}>{tr("В процессе")}</Tag>
										)}
									</td>
								</tr>
								{activeItems.length !== 0 && completedItems.length > 0 && (
									<>
										<tr>
											<td>
												<div className="text-link-style ws-no-wrap d-flex align-items-center pl-30">
													<button
														className="table-toggle-button"
														onClick={toggleCompleted}
													>
														{openedCompleted ? "-" : "+"}
													</button>
													<span>{item.name}</span>
												</div>
											</td>
											<td></td>
											<td>
												<div className="text-cen ws-no-wrap">
													{helpers.convertToReadable(
														completedItems.reduce(
															(sum, i) => sum + Number(i.quantity),
															0
														)
													)}
												</div>
											</td>

											<td></td>

											<td>
												<div className="text-right ws-no-wrap">
													{helpers.convertToReadable(
														completedItems.reduce(
															(sum, i) => sum + Number(i.sum),
															0
														)
													)}{" "}
													{defaultCurrency.toUpperCase()}
												</div>
											</td>

											<td className="text-right ws-no-wrap">
												{helpers.convertToReadable(
													completedItems.reduce(
														(sum, i) => sum + Number(i.coming_price),
														0
													)
												)}{" "}
												{defaultCurrency.toUpperCase()}
											</td>

											<td className="text-right ws-no-wrap">
												{helpers.convertToReadable(
													completedItems.reduce(
														(sum, i) =>
															sum + (Number(i.sum) - Number(i.coming_price)),
														0
													)
												)}{" "}
												{defaultCurrency.toUpperCase()}
											</td>
											<td></td>
										</tr>

										{openedCompleted &&
											completedItems.map(item => {
												const price = Number(item.price);
												const coming = Number(item.coming_price);
												const profit = Number(item.sum) - coming;

												return (
													<tr key={`completed-${item.id}`}>
														<td className="text-link-style ws-no-wrap d-flex align-items-center ">
															<span className="pl-60">{item.name}</span>
														</td>
														<td>{item.unit}</td>
														<td className="text-cen">{helpers.convertToReadable(helpers.checkNumber(item.quantity))}</td>
														<td className="text-right ws-no-wrap">
															{helpers.convertToReadable(price)}{" "}
															{defaultCurrency.toUpperCase()}
														</td>
														<td className="text-right ws-no-wrap">
															{helpers.convertToReadable(item.sum)}{" "}
															{defaultCurrency.toUpperCase()}
														</td>
														<td className="text-right ws-no-wrap">
															{helpers.convertToReadable(coming)}{" "}
															{defaultCurrency.toUpperCase()}
														</td>
														<td className="text-right ws-no-wrap">
															{helpers.convertToReadable(profit)}{" "}
															{defaultCurrency.toUpperCase()}
														</td>
														<td>
															{item.status === 1 ? (
																<Tag color={"green"}>{tr("Завершено")}</Tag>
															) : (
																<Tag color={"blue"}>
																	{tr("В процессе")}
																</Tag>
															)}
														</td>
													</tr>
												);
											})}
									</>
								)}
							</>
						);
					})}
				</>
			)}
		</>
	);
};

export default Item;

// import React from "react";
// import { helpers } from "../../../services";
// import config from "../../../config";
// import { Tag } from "../../../components";
// import useTranslation from "../../../hooks/useTranslation";

// const Item = ({ list, ind, defaultCurrency, toggleClosedKeys, openedRows }) => {
// 	const { tr } = useTranslation();

// 	const p = list.find(l => l.is_set_child === 0);
// 	const f = list[0];
// 	const parent = p ? p : f;
// 	const quantity = list.reduce((prev, curr) => prev + Number(curr.quantity), 0);
// 	const comingPrice = list.reduce(
// 		(prev, curr) => prev + Number(curr.coming_price),
// 		0
// 	);
// 	const sum = list.reduce((prev, curr) => prev + Number(curr.sum), 0);

// 	const isOpened = openedRows.find(o => o === parent.product_id);
// 	return (
// 		<>
// 			<tr>
// 				<td>
// 					<div className="d-flex align-items-center">
// 						<button
// 							className="table-toggle-button"
// 							onClick={() => toggleClosedKeys(parent.product_id)}
// 						>
// 							{isOpened ? "-" : "+"}
// 						</button>
// 						<span className="text-link-style ws-no-wrap">
// 							{ind + 1}. {parent ? parent.name : list[0].name}
// 						</span>
// 					</div>
// 				</td>
// 				<td>{parent.unit}</td>
// 				<td className={"text-cen"}>{quantity}</td>
// 				<td className="ws-no-wrap text-right">
// 					{helpers.convertToReadable(sum / quantity)}{" "}
// 					{defaultCurrency && defaultCurrency.toUpperCase()}
// 				</td>
// 				<td className="ws-no-wrap text-right">
// 					{helpers.convertToReadable(sum)}{" "}
// 					{defaultCurrency && defaultCurrency.toUpperCase()}
// 				</td>
// 				<td className="ws-no-wrap text-right">
// 					{helpers.convertToReadable(comingPrice)}{" "}
// 					{defaultCurrency && defaultCurrency.toUpperCase()}
// 				</td>
// 				<td className="ws-no-wrap text-right">
// 					{helpers.convertToReadable(sum - comingPrice)}{" "}
// 					{defaultCurrency && defaultCurrency.toUpperCase()}
// 				</td>
// 				<td>
// 					{parent.status === config.ORDER_STATUS_COMPLETED ? (
// 						<Tag color={"green"}>{tr("Завершено")}</Tag>
// 					) : (
// 						<Tag color={"blue"}>{tr("Готовится блюдо")}</Tag>
// 					)}
// 				</td>
// 			</tr>
// 			{isOpened &&
// 				list.map(item => {
// 					const price = item.price ? Number(item.price) : 0;
// 					const comingPrice = item.coming_price ? Number(item.coming_price) : 0;
// 					const sum = item.sum ? Number(item.sum) : 0;
// 					const profit = sum - comingPrice;

// 					return (
// 						<tr>
// 							<td>
// 								<span className="ws-no-wrap pl-30">
// 									{item.set_product ? item.set_product : item.name}
// 								</span>
// 							</td>
// 							<td>{item.unit}</td>
// 							<td className="text-cen">{item.quantity}</td>
// 							<td className={"ws-no-wrap text-right"}>
// 								{helpers.convertToReadable(price)}{" "}
// 								{defaultCurrency && defaultCurrency.toUpperCase()}
// 							</td>
// 							<td className="ws-no-wrap text-right">
// 								{helpers.convertToReadable(sum)}{" "}
// 								{defaultCurrency && defaultCurrency.toUpperCase()}
// 							</td>
// 							<td className="ws-no-wrap text-right">
// 								{helpers.convertToReadable(comingPrice)}{" "}
// 								{defaultCurrency && defaultCurrency.toUpperCase()}
// 							</td>
// 							<td className="ws-no-wrap text-right">
// 								{helpers.convertToReadable(profit)}{" "}
// 								{defaultCurrency && defaultCurrency.toUpperCase()}
// 							</td>
// 							<td>
// 								{item.status === config.ORDER_STATUS_COMPLETED ? (
// 									<Tag color={"green"}>{tr("Завершено")}</Tag>
// 								) : (
// 									<Tag color={"blue"}>{tr("Готовится блюдо")}</Tag>
// 								)}
// 							</td>
// 						</tr>
// 					);
// 				})}
// 		</>
// 	);
// };

// export default Item;
